export default {
  removeWarning:
    "En continuant, ce movement sera supprimé, et n'affectera aucune autre de vos données.",
  cancelWarning:
    "En continuant, ce movement sera supprimé, et la quantité de celui-ci sera retranchée du stock.",
  price: "Prix",
};
